module.exports = "<div class=\"center-block\">\n    <header>\n        <h3>{{_.i18n('Erasure options')}}</h3>\n    </header>\n\n    <button id=\"btn--wipe\" type=\"button\" class=\"btn btn-default btn-block\">\n        <i class=\"icon-lock\"></i>\n        {{_.i18n('Erase user profile on this computer')}}\n    </button>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/show/wipe/template.html
// module id = 1345
// module chunks = 0